// extracted by mini-css-extract-plugin
module.exports = {"alert":"alerts_alert__luc2e","alert-dismiss":"alerts_alert-dismiss__N1VIL"};